import { Flag } from "@medbillai/utils/flag";

import { useEnumVariation } from "../flag";
import { ONBOARDING_VERSIONS, type OnboardingFlowVersion } from "./types";
export const useOnboardingFlowVariation = (): OnboardingFlowVersion =>
  useEnumVariation<OnboardingFlowVersion>(
    ONBOARDING_VERSIONS,
    Flag.USE_ONBOARDING_FLOW,
    "v1.0",
  );
